import React, { FC } from 'react'
import classNames from 'classnames'
import { useStopsSummaryConnectorIcon } from 'apps/fleet-planner/components/load-details/stops/StopsSummaryStyles'

export const StopIconEllipsis = () => {
  return (
    <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='6' cy='6' r='5' fill='white' stroke='currentColor' strokeWidth='2' />
    </svg>
  )
}

interface IStopsSummaryConnectorIconProps {
  isMultiStop: boolean
  compact: boolean
}

export const StopsSummaryConnectorIcon: FC<IStopsSummaryConnectorIconProps> = ({
  compact = false,
  isMultiStop = false,
}) => {
  const styles = useStopsSummaryConnectorIcon({ compact })
  const classes = classNames(styles.root, {
    [styles.multiStop]: isMultiStop,
  })

  return (
    <span className={classes}>
      <StopIconEllipsis />
    </span>
  )
}
